import { render, staticRenderFns } from "./NavigationWithArrows.vue?vue&type=template&id=20b1ced1&scoped=true&"
import script from "./NavigationWithArrows.vue?vue&type=script&lang=js&"
export * from "./NavigationWithArrows.vue?vue&type=script&lang=js&"
import style0 from "./NavigationWithArrows.vue?vue&type=style&index=0&id=20b1ced1&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20b1ced1",
  null
  
)

export default component.exports